(function () {
  'use strict';

  angular
    .module('individualCrewExpiryReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('individualCrewExpiryReport', {
        url: '/individual-crew-expiry-report',
        views : {
			'individualCrewExpiryReportView' : {
				templateUrl : 'individual-crew-expiry-report/views/individual-crew-expiry-report.tpl.html',
				controller : 'IndividualCrewExpiryReportCtrl',
				controllerAs : 'individualCrewExpiryReport'
			}
		},
      });
  }
}());
